import React from 'react';
import { CharacterRole, Fleet, GameState, StarSystem } from '../../types';
import WorldPanel from './WorldPanel';
import FleetPanel from './FleetPanel';

type Props = {
  selectedSystem: StarSystem | null;
  selectedFleets: Fleet[];
  gameState: GameState;
  myPlayerId: string | null;
  onBuildShip: (systemId: number, shipClass: 'frigate' | 'destroyer' | 'cruiser' | 'capital', targetFleetId?: number) => void;
  onBuildShipyard: (systemId: number) => void;
  onRepairFleet: (fleetId: number) => void;
  onMoveFleet: (fleetId: number, destinationId: number) => void;
  onCombineFleets: (fleetIds: number[]) => void;
  onDivideFleet?: (fleetId: number, count: number) => void;
  onAssignCharacterRole: (role: CharacterRole, targetId: number) => void;
};

export default function CommandConsole(props: Props) {
  const { selectedSystem, selectedFleets, gameState, myPlayerId } = props;
  const isOpen = Boolean(selectedSystem || selectedFleets.length > 0);

  return (
    <div className={`command-console ${isOpen ? 'open' : ''}`}>
      {!isOpen && (
        <div className="empty-state">
          <div className="title">System Control</div>
          <div className="subtitle">No Selection</div>
          <div className="hint">Click on a star system or fleet to view details and issue orders.</div>
        </div>
      )}

      {selectedSystem && (
        <WorldPanel
          system={selectedSystem}
          gameState={gameState}
          myPlayerId={myPlayerId}
          onBuildShip={props.onBuildShip}
          onBuildShipyard={props.onBuildShipyard}
          onRepairFleet={props.onRepairFleet}
          onMoveFleet={props.onMoveFleet}
          onAssignCharacterRole={props.onAssignCharacterRole}
        />
      )}

      {!selectedSystem && selectedFleets.length > 0 && (
        <>
          {selectedFleets.length > 1 && (
            <div className="console-header sticky">
              <div className="title">{selectedFleets.length} Fleets Selected</div>
              <button className="action primary" onClick={() => props.onCombineFleets(selectedFleets.map(f => f.id))}>🔗 Combine</button>
            </div>
          )}
          <FleetPanel
            fleet={selectedFleets[0]}
            gameState={gameState}
            myPlayerId={myPlayerId}
            onMoveFleet={props.onMoveFleet}
            onCombineFleets={props.onCombineFleets}
            onDivideFleet={props.onDivideFleet}
            onAssignCharacterRole={props.onAssignCharacterRole}
          />
        </>
      )}
    </div>
  );
}


